/**
 * 📋 SDLC 6.3.1 UNIFIED SPECIFICATION STANDARD FILE HEADER
 * ===============================================================================
 * FILE: frontend/src/pages/CompensationMasterData/JobFamilies.tsx
 * PURPOSE: Job Family management page — thin wrapper mounting the generic
 *          MasterDataCrudPage with jobFamilySchema (BR-COMP-002 §8 R1).
 * SDLC FRAMEWORK VERSION: 6.3.1 (7-Pillar + 3-Section + Long-Running Agent Protocol)
 * DATE: 2026-07-12
 * COMPLIANCE: SDLC 6.3.1 + BR-PLAT-001-MASTER-DATA-CRUD-IMPORT-EXPORT-STANDARD
 * PILLAR: P1 (Stage 06 - BUILD) + P6 (UI/UX Design)
 * SPRINT GOVERNANCE: Rule 4: Tier-3 Code Review
 *
 * @business-context
 * - Domain: Vietnamese Compensation Master Data
 * - Impact: Closes BR-2.9 — Tenant Admin can finally configure job families
 *   (and their bonus multiplier) without direct DB scripts
 * - Stakeholders: CFO / HR Director (TENANT_ADMIN)
 *
 * @technical-architecture
 * - Layer: Frontend Presentation Layer
 * - Pattern: Config-Driven UI (all behavior comes from jobFamilySchema)
 * - Dependencies: frontend/src/components/master-data/MasterDataCrudPage.tsx
 *
 * @cross-references
 * - Schema: frontend/src/pages/CompensationMasterData/jobFamilySchema.ts
 * - Route: frontend/src/App.tsx (/tenant-admin/compensation/job-families — TenantAdminLayout guard)
 * - BR: docs/01-planning/01-requirements/08-compensation/BR-COMP-002-job-family-paygrade-management.md
 */

import React from 'react';
import { MasterDataCrudPage } from '@/components/master-data/MasterDataCrudPage';
import { jobFamilySchema } from './jobFamilySchema';

export const JobFamilies: React.FC = () => {
  return <MasterDataCrudPage schema={jobFamilySchema} />;
};

export default JobFamilies;
